import HelpCenter from './HelpCenter'

export default HelpCenter



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/help/components/index.js